import { MeSettings } from '../models/meSettings';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { client } from '../api/client';
import { ThunkState, addHandlers } from '../app/utils/reducerUtils';

type MeSettingsState = ThunkState & MeSettings
const serviceName = 'me';

export const loadMeSettings = createAsyncThunk('me/settings', async () => {
  const response = await client.get<MeSettings>(serviceName);
  return response;
});

const initialState: MeSettingsState = {
  pending: 'idle',
  errors: [],
  sidepanelExpanded: false,
  columnSettings: {}
};

export const meSettingsSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {
    setGridConfiguration: (state, action) => {
      const settings = { ...action.payload, pending: undefined, errors: undefined } as MeSettings;
      client.post<MeSettings>(`${serviceName}`, settings);
      return action.payload;
    },
  },
  extraReducers: builder => {
    addHandlers({
      builder,
      thunk: loadMeSettings,
      onSuccess(state, action) {
        state.sidepanelExpanded = action.payload.sidepanelExpanded;
        state.columnSettings = action.payload.columnSettings;
      },
    });

  },
});

export default meSettingsSlice.reducer;

export const {
  setGridConfiguration
} = meSettingsSlice.actions;

